import AsyncFlow from '../asyncFlow';

//utils
import { isValid, startOfToday, isBefore, isAfter } from 'date-fns';
import subDays from 'date-fns/subDays';
import addMonths from 'date-fns/addMonths'


export default AsyncFlow({
    store: 'edit-data-scadenza-license',
    initialState: {

        data_scadenza: null,    // data scadenza attuale
        new_data_scadenza: null,
        hasScadenza: false,

        num_mesi: 0,

        errorText: '',

        isChanged: false,
        isValid: true,

        isOpen: false,
        isModified: '',
        statusAction: 'READY',
    },
    actions: ['EDIT_DATA_SCAD', 'SHOW_EDIT_DATA_SCAD_DIALOG', 'INITIALIZE_FIELDS', 'HANDLE_CHANGE_FIELD', 'VALIDATE_FIELD', 'RESET_STORE'],
}).extend({
    reducer: (state, action, { types }) => {

        var errorText_temp = state.errorText;
        var hasScadenza_temp = false;

        switch (action.type) {

            case types.RESET_STORE:
                return {
                    ...state,
                    data_scadenza: null,    // data scadenza attuale
                    new_data_scadenza: null,
                    hasScadenza: false,
                    num_mesi: 0,
                    errorText: '',
                    isChanged: false,
                    isValid: true,
                    isOpen: false,
                    isModified: '',
                };

            case types.EDIT_DATA_SCAD_SUCCESS:
                return {
                    ...state,
                    isModified: action.payload.isModified
                };

            case types.SHOW_EDIT_DATA_SCAD_DIALOG:
                return {
                    ...state,
                    isOpen: !state.isOpen
                };

            case types.INITIALIZE_FIELDS:
                hasScadenza_temp = false;
                if (action.payload.value !== null) hasScadenza_temp = true;

                return {
                    ...state,
                    data_scadenza: action.payload.value,
                    new_data_scadenza: action.payload.value,
                    hasScadenza: hasScadenza_temp
                };

            case types.HANDLE_CHANGE_FIELD:

                var new_data_scadenza_temp = state.new_data_scadenza;
                hasScadenza_temp = state.hasScadenza;
                var num_mesi_temp = state.num_mesi;

                if (action.payload.field === 'hasScadenza') {
                    hasScadenza_temp = action.payload.newValue;

                    if (hasScadenza_temp === false) {
                        new_data_scadenza_temp = null;
                        errorText_temp = '';
                    }
                    else {
                        // se data_scadenza === null e ho selezionato "Nessuna scadenza" setto come default la data di oggi
                        if (state.data_scadenza !== null)
                            new_data_scadenza_temp = state.data_scadenza;
                        else new_data_scadenza_temp = startOfToday();
                    }
                }
                else if (action.payload.field === 'new_data_scadenza') {
                    new_data_scadenza_temp = action.payload.newValue;
                }
                else if (action.payload.field === 'num_mesi') {

                    num_mesi_temp = action.payload.newValue;

                    if (state.hasScadenza === false)
                        new_data_scadenza_temp = null;
                    else
                        if (num_mesi_temp !== '') {

                            // se data_scadenza === null e ho selezionato "Nessuna scadenza" aggiungo mesi per default alla data di oggi
                            if (state.data_scadenza !== null)
                                new_data_scadenza_temp = addMonths(state.data_scadenza, parseInt(num_mesi_temp));
                            else new_data_scadenza_temp = addMonths(startOfToday(), parseInt(num_mesi_temp));

                        }

                }

                // controllo se data scadenza è cambiata rispetto a quella originale
                var isChanged_temp = state.isChanged;

                if (new_data_scadenza_temp !== state.data_scadenza) isChanged_temp = true;
                else isChanged_temp = false;

                return {
                    ...state,
                    new_data_scadenza: new_data_scadenza_temp,
                    hasScadenza: hasScadenza_temp,
                    num_mesi: num_mesi_temp,
                    isChanged: isChanged_temp
                };

            case types.VALIDATE_FIELD:

                if (state.hasScadenza === true) {
                    if (state.new_data_scadenza !== null && isValid(state.new_data_scadenza)) {

                        if (isBefore(state.new_data_scadenza, subDays(startOfToday(), 1)) || isAfter(state.new_data_scadenza, new Date(2100, 1, 1)))
                            errorText_temp = 'Data Scadenza fuori range.';
                        else
                            errorText_temp = '';
                    }
                    else errorText_temp = 'Data Scadenza non valida.';
                } else errorText_temp = '';

                // controllo se ci sono errori di validazione
                var isValid_temp = false;

                if (errorText_temp === '') isValid_temp = true;
                else isValid_temp = false;


                return {
                    ...state,
                    errorText: errorText_temp,
                    isValid: isValid_temp
                };


            default:
                return state;
        }
    },
    creators: ({ types }) => ({

        editDataScadRequest: (pk, data_scadenza, codiceUtente) => ({
            type: types.EDIT_DATA_SCAD_REQUEST,
            payload: { pk, data_scadenza, codiceUtente },
        }),
        editDataScadSuccess: ({ isModified }) => ({
            type: types.EDIT_DATA_SCAD_SUCCESS,
            payload: { isModified },
        }),
        editDataScadFailed: error => ({ type: types.EDIT_DATA_SCAD_FAILED, error: true, payload: { error } }),

        //inizializzo data_scadenza e new_data_scadenza
        initializeFields: (value) => ({
            type: types.INITIALIZE_FIELDS,
            payload: { value },
        }),
        showEditDataScadDialog: () => ({
            type: types.SHOW_EDIT_DATA_SCAD_DIALOG,
        }),
        handleChangeField: (field, newValue) => ({
            type: types.HANDLE_CHANGE_FIELD,
            payload: { field, newValue },
        }),
        validateField: (field) => ({
            type: types.VALIDATE_FIELD,
            payload: { field },
        }),


        resetEditDataScad: () => ({
            type: types.RESET_STORE,
        }),
    }),
});
